var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../buttons/tool-icon-button.js';
import { WithDisposable } from '@blocksuite/lit';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { GroupIcon } from '../../../../_common/icons/index.js';
let EdgelessAddGroupButton = class EdgelessAddGroupButton extends WithDisposable(LitElement) {
    render() {
        return html ` <edgeless-tool-icon-button
      .iconContainerPadding=${2}
      @click=${() => {
            this.edgeless.surface.group.createGroupOnSelected();
        }}
      .tooltip=${'Group'}
      .tipPosition=${'bottom'}
    >
      ${GroupIcon}<span
        style=${styleMap({
            fontSize: '12px',
            fontWeight: 400,
            color: 'var(--affine-icon-color)',
            marginLeft: '4px',
        })}
        >Group</span
      >
    </edgeless-tool-icon-button>`;
    }
};
__decorate([
    property({ attribute: false })
], EdgelessAddGroupButton.prototype, "edgeless", void 0);
EdgelessAddGroupButton = __decorate([
    customElement('edgeless-add-group-button')
], EdgelessAddGroupButton);
export { EdgelessAddGroupButton };
//# sourceMappingURL=add-group-button.js.map